setTimeout(() => {
    const menu = {
        wrapper: {},
        container: {},
        level: {},
        active: {},
        activeElement: {},
        activeDelay: 100,
        data: {
            categories: {}
        },
        state: {
            open: false
        }
    };

    document.addEventListener('keydown', (event) => {
        let inputTags = [ 'INPUT', 'TEXTAREA' ];

        if ( inputTags.includes(event.target.tagName)) return;

        switch (event.code) {
            case 'KeyM':
                menu.state.open ? menu.close() : menu.open();
                break;
            case 'Escape':
                menu.close();
                break;
        }
    });

    document.addEventListener('mouseover', (event) => {
        if ( window.innerWidth >= 1000 && event.target.parentNode.classList.contains('open-products-categories') ) {
            toggleMenu(event);
            return;
        }
    });

    document.addEventListener('click', (event) => {
        if ( event.target.parentNode.classList.contains('open-products-categories') ) {
            toggleMenu(event);
            return;
        }

        if  ( menu.state.open && !event.target.closest('.impex-product-menu, .menu-button, .open-products-categories') ) {
            menu.close();
        }
    });
    

    menu.reset = () => {
        handleColumnClasses(0);
    }

    menu.open = () => {
        const container = document.getElementsByClassName('wrap').item(0);

        if (!container || menu.state.open) {
            return;
        }

        menu.state.open = true;

        if ( Object.keys(menu.wrapper).length === 0 ) {
            menu.wrapper = document.createElement('div');
            menu.wrapper.classList.add('impex-product-menu-wrapper');
        }

        if (!container.contains( menu.wrapper )) {
            container.prepend( menu.wrapper );
        }

        if ( Object.keys(menu.container).length === 0 ) {
            menu.container = document.createElement('section');
            menu.container.classList.add('impex-product-menu');
            menu.container.addEventListener('mouseleave', menu.close ); //Comment out for development
        }

        menu.level['nav'] = document.createElement('div');
        menu.level['nav'].classList.add('menu-list', `menu-list__nav`);

        addBackLink();

        fetchCategories(0, 0, true ); // Root category ID is 0

        if (!menu.wrapper.contains( menu.container )) {
            menu.wrapper.prepend( menu.container );
        }
        toggleBodyClass();
    };

    menu.close = () => {
        menu.state.open = false;
        menu.container.remove();
        toggleBodyClass();
    };

    menu.back = () => {
        objKeys = Object.keys(menu.active);

        let prevElement = objKeys.length - 1;
        if (prevElement >= 0) {
            menu.active[objKeys[prevElement]].classList.remove('active');
            delete menu.active[objKeys[prevElement]];
        }

        prevElement--;

        if (prevElement >= 0) {
            menu.active[objKeys[prevElement]].click();
            menu.active[objKeys[prevElement]].focus();
            menu.active[objKeys[prevElement]].scrollIntoView();
        } else {

            menu.reset();
            if (prevElement == -2) {
                menu.close();
            }
        }
    }

    function toggleMenu(event) {
        let mobile_main_menu = event.target.parentNode.parentNode.parentNode;
        let mobileMenuComputedStyle = getComputedStyle(mobile_main_menu).display;

        if ( mobileMenuComputedStyle === "block" ) {
            mobile_main_menu.style.display = "none";
        } else {
            mobile_main_menu.style.display = "block";
        }

        event.preventDefault();
        menu.state.open ? menu.close() : menu.open();
    }

    function toggleBodyClass() {
        let body = document.getElementsByTagName('body').item(0);

        menu.state.open ? body.classList.add('menu-open') : body.classList.remove('menu-open');
    }

    function addBackLink() {
        let backLink = document.createElement('a');
        backLink.classList.add('back-link');
        backLink.title = 'Gå tilbake';
        backLink.href = '#';
        backLink.addEventListener('click', menu.back );
        menu.level['nav'].prepend( backLink );
        menu.container.prepend( menu.level['nav'] );
    }

    function addShadowElement( element, ...classes ) {
        const shadow = document.createElement('div');
        classes.forEach( cls => {
            shadow.classList.add( cls );
        });
        element.prepend( shadow );
    }

    function fetchSubCategories() {
        fetch(`/wp-json/impex/v1/subcategories`)
            .then(response => response.json())
            .then(data => {
                storeSubCategoryData(data);
            })
            .catch(error => console.error('Error fetching subcategories:', error));
    }

    function fetchCategories(categoryId, level, update = false) {
        if ( typeof menu.data.categories[categoryId] !== 'undefined' ) {
            if ( menu.data.categories[categoryId].parent.url || typeof menu.data.categories[categoryId].children != 'undefined' ) {
                // Get stored data if URL (should have no children) or children are stored
                updateCategoriesView(menu.data.categories[categoryId],level);
                return;
            }
        }

        fetch(`/wp-json/impex/v1/categories/${categoryId}`)
            .then(response => response.json())
            .then(data => {
                if ( update ) {
                    updateCategoriesView(data, level);
                }
                storeCategoryData(categoryId, data);
            })
            .catch(error => console.error('Error fetching categories:', error));
    }

    function storeCategoryData(categoryId, data) {
        menu.data.categories[categoryId] = data;

        Object.values(data.children).forEach(child => {
            if ( typeof menu.data.categories[child.term_id] == 'undefined' ) {
                menu.data.categories[child.term_id] = {};
            }
            menu.data.categories[child.term_id].parent = child;
        });
    }

    function storeSubCategoryData(data) {
        Object.values(data.children).forEach(child => {
            if (typeof menu.data.categories[child.term_id] == 'undefined') {
                menu.data.categories[child.term_id] = {};
                //menu.data.categories[subcategory.parent] = subcategory;
            }

            menu.data.categories[child.term_id].cached = data.cached;

            if (typeof menu.data.categories[child.term_id].parent == 'undefined') {
                menu.data.categories[child.term_id].parent = child;
            } else {
                menu.data.categories[child.term_id].parent = Object.assign(menu.data.categories[child.term_id].parent, subcategory);
            }
        });
        Object.values(data.children).forEach(child => {
            if (typeof menu.data.categories[child.parent] == 'undefined') {
                return;
            }

            if (typeof menu.data.categories[child.parent].children !== 'object') {
                menu.data.categories[child.parent].children = [];
            }
            menu.data.categories[child.parent].children.push(child);
        });
    }

    function handleColumnClasses(level) {
        if ( level > 0 ) {
            menu.container.classList.add(`col-${level}`);
        }

        menu.container.classList.forEach(cls => {
            if ( cls.startsWith('col-') && parseInt(cls.split('-')[1]) > level ) {
                menu.container.classList.remove( cls );
            }
        });

        addShadowElement( menu.level[level],'shadow', 'shadow__top' );
        addShadowElement( menu.level[level],'shadow', 'shadow__bottom' );
    }

    function handleOrphanedColumns( level ) {
        let depth = level + 2;
        while ( typeof menu.level[depth] !== 'undefined' ) {
            menu.level[depth].remove();
            depth++;
        }
    }

    function handleActiveClass( element, level ) {
        element.classList.add('active');

        if ( typeof menu.active[level] == 'undefined' ) {
            menu.active[level] = element;
        }

        if ( element !== menu.active[level] ) {
            unsetActiveElement( level );
            menu.active[level] = element;
        }
    }

    function unsetActiveElement( level ) {
        if (typeof menu.active[level] !== 'undefined') {
            menu.active[level].classList.remove('active');
        }
    }

    function handleEmptyClass( empty, level ) {
        const classList = menu.container.classList;

        level++;

        if ( empty ) {
            classList.add(`empty-${level}`);
            classList.forEach(cls => {
                if ( cls.startsWith('empty-') && parseInt(cls.split('-')[1]) > level ) {
                    classList.remove( cls );
                }
            });
        } else {
            classList.forEach(cls => {
                if ( cls.startsWith('empty-') && parseInt(cls.split('-')[1]) >= 0 ) {
                    classList.remove( cls );
                }
            });
        }
    }

    function updateCategoriesView(categoryData, level) {  
        if ( typeof menu.level[level] == 'undefined' ) {
            menu.level[level] = document.createElement('div');
            menu.level[level].classList.add( 'menu-list', `menu-list__${level}`);
        } else {
            menu.level[level].innerHTML = ''; // Clear existing content
        }

        let columnLevel = level;

        let categoryName = '';
        let categoryURL = '/';

        if ( categoryData.parent  ) {
            if ( categoryData.parent.name ) {
                categoryName = `${categoryData.parent.name}`;
            }

            if ( categoryData.parent.parent_url ) {
                categoryURL = categoryData.parent.parent_url;
            }
        }

        handleColumnClasses(columnLevel);

        const container = document.createElement('div');
        container.classList.add( 'scroll' );

        const topLink = document.createElement('a');
        topLink.classList.add( 'all' );

        if (categoryName) {
            topLink.href = categoryURL;
            topLink.textContent = `${categoryName}`;
        }

        topLink.addEventListener('mouseover', (event) => {
            if ( menu.activeDelay > 0 ) {
                setTimeout(() => {
                    unsetActiveElement(columnLevel);
                }, menu.activeDelay);
            } else {
                unsetActiveElement(columnLevel);
            }
        });

        if (categoryName) {
            container.append(topLink);
        }

        categoryData.children.forEach(child => {
            const link = document.createElement('a');
            link.href = child.url ? child.url : child.parent_url;
            link.textContent = child.name;

            if ( !child.url ) {
                link.classList.add('parent-url');
            }

            link.addEventListener('click', (event) => {
                handleCategoryViewEvents(event, child, level);
            });

            link.addEventListener('mouseout', (event) => {
                if (menu.activeElement && menu.activeElement !== event.target) {
                    handleActiveClass(event.target.level);
                }
            });

            link.addEventListener('mouseover', (event) => {
                menu.activeElement = event.target;
                if ( menu.activeDelay > 0 ) {
                    setTimeout(() => {
                        if (menu.activeElement !== event.target) {
                            return;
                        }
                        handleCategoryViewEvents(event, child, level);
                    }, menu.activeDelay);
                } else {
                    handleCategoryViewEvents(event, child, level);
                }
            });

            container.append(link);
        });

        menu.level[level].append(container);
        menu.container.prepend(menu.level[level]);
    }

    function handleCategoryViewEvents(event, child, level) {
        if ( window.screen.width >= 750  ) {
            if (event.type == 'click') return;
        } else {
            if (event.type == 'mouseover') return;
        }

        let nextLevel = level + 1;

        handleActiveClass(event.target, level);
        handleEmptyClass( (child.url.length), level );

        if (!child.url) {
            event.preventDefault();
            handleOrphanedColumns(level);
            fetchCategories(child.term_id, nextLevel, true);
        }
    }

    setTimeout(() => {
        fetchCategories(0, 0, false );
    }, 0);

    setTimeout(() => {
        fetchSubCategories();
    }, 500);


}, 0);
